import { render, staticRenderFns } from "./TreeCo2Specie.vue?vue&type=template&id=2f3e8cd4&"
import script from "./TreeCo2Specie.vue?vue&type=script&lang=ts&"
export * from "./TreeCo2Specie.vue?vue&type=script&lang=ts&"
import style0 from "./TreeCo2Specie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports